<style>
.el-tree-node__label {
    font-size: 12px;
}
</style>
<template>
  <div class="check-work-body d-flex">
    <div class="d-flex-left">
      <div class="tree-wrap">
        <div class="project-selector">
          <el-select size="mini" style="width: 100%" v-model="jurisdictionId" filterable placeholder="选择架构"
                     @change="checkedGetList">
            <el-option v-for="item in jurisdictionList" :key="item.id" :label="item.department_name"
                       :value="item.id">
            </el-option>
          </el-select>
          <el-button size="mini" @click="refreshTree" type="success">重置</el-button>
        </div>
        <div class="el-tree-1">
          <el-tree ref="tree" :data="data" :empty-text="emptyText" :props="defaultProps" :lazy="true"
                   :load="getData" @node-click="handleNodeClick"></el-tree>
        </div>
      </div>
    </div>

    <div class="d-flex-right">
      <!-- 搜索框 -->
      <div class="search-wrap">
        <el-row>
          <el-col :span="24">
            <el-button size="mini" @click="exportSalary()" type="warning">导出</el-button>
            <el-button size="mini" @click="handleNodeClick" type="primary">查询</el-button>
            <el-button size="mini" @click="clearSearch" type="primary">重置查询</el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 搜索框 -->
      <div style="margin-bottom: 10px;">
        <el-descriptions :column="3" border size="mini">
          <el-descriptions-item label="年份">
            <el-date-picker size="mini" v-model="keyword.year" type="year" value-format="yyyy" format="yyyy" placeholder="选择年"></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="月份">
            <el-date-picker size="mini" v-model="keyword.month" type="month" value-format="M" format="M" placeholder="选择月"></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="姓名">
            <el-input size="mini" placeholder="" v-model="keyword.name" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="机构">
            <el-input size="mini" placeholder="" v-model="keyword.organization" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="项目">
            <el-select v-model="keyword.project_ids" placeholder="选择项目" multiple filterable>
              <el-option v-for="item in projectList" :key="item.id" :label="item.value" :value="item.id">{{item.value}}</el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="身份证">
            <el-input size="mini" placeholder="" v-model="keyword.identity_card" clearable></el-input>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="table-wrap">
        <el-table v-if="pageData" v-loading="loading"
                  :data="pageData.list"
                  :cell-style="cellStayle">
          <el-table-column fixed prop="name" label="姓名" align="center" width="" fixed></el-table-column>
          <el-table-column prop="project" label="项目" align="center" width="180" fixed></el-table-column>
          <el-table-column prop="salary_year" label="发薪年份" align="center" width="50"></el-table-column>
          <el-table-column prop="salary_month" label="发薪月份" align="center" width="50"></el-table-column>
          <el-table-column prop="ought_to_attendance" label="应出勤" align="center" width="50"></el-table-column>
          <el-table-column prop="practical_attendance" label="实际出勤" align="center" width="50"></el-table-column>
          <el-table-column prop="salary_count_day" label="工资核算天数" align="center" width="50"></el-table-column>
          <el-table-column prop="normal_salary" label="正常工作时间工资" align="center" width=""></el-table-column>
          <el-table-column prop="fixed_overtime_salary" label="固定加班工资" align="center" width=""></el-table-column>
          <el-table-column prop="perf_salary" label="绩效工资" align="center" width=""></el-table-column>
          <el-table-column prop="actual_attendance_salary" label="实际出勤工资" align="center" width=""></el-table-column>
          <el-table-column prop="overtime_salary" label="加班费" align="center" width=""></el-table-column>
          <el-table-column prop="temperature_money" label="高温费" align="center" width=""></el-table-column>
          <el-table-column prop="festival_money" label="过节费" align="center" width=""></el-table-column>
          <el-table-column prop="internship_money" label="顶岗费" align="center" width=""></el-table-column>
          <el-table-column prop="other_money" label="其他奖励" align="center" width=""></el-table-column>
          <el-table-column prop="absence" label="考勤奖罚" align="center" width=""></el-table-column>
          <el-table-column prop="ought_to_salary" label="应发工资" align="center" width=""></el-table-column>
          <el-table-column prop="housing_provident_fund" label="住房公积金" align="center" width=""></el-table-column>
          <!--      <el-table-column prop="agent_subtract_money_total" label="扣除金额" align="center" width=""></el-table-column>-->
          <el-table-column prop="social_security_money" label="社保费" align="center" width=""></el-table-column>
          <el-table-column prop="housing_provident_fund" label="公积金" align="center" width=""></el-table-column>
          <el-table-column prop="work_injury_insurance" label="工伤险" align="center" width=""></el-table-column>
          <el-table-column prop="income_tax" label="个人税" align="center" width=""></el-table-column>
          <el-table-column prop="other_subtract_money" label="其他扣款" align="center" width=""></el-table-column>
          <el-table-column prop="special_reward" label="特殊奖罚" align="center" width=""></el-table-column>
          <el-table-column prop="actual_salary" label="实发工资" align="center" width=""></el-table-column>
          <el-table-column prop="remark" label="备注" align="center" width=""></el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div>
        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total=pageData.total
                         :page-size="pageData.pageSize * 1" :current-page="pageData.page * 1"
                         @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>


  </div>
</template>

<script>

import Http from "./common/Http";

export default {
  name: "preSalary",
  data() {
    return {
      jurisdictionId: '',
      jurisdictionList: [],
      data: [],
      emptyText: '没有数据',
      defaultProps: {
        children: '',
        label: 'department_name'
      },
      keyword: {},
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 10,
        page: 1
      },
      statusTotal: {
        pass_process_total: 0,
        not_process_total: 0,
      },
      nodeLevel: '',
      department_id: "",
      options: [],
      projectList: [],
    }
  },
  // 获取列表
  mounted() {
    this.getHuaRuiDepartmentList();
    this.getPreUserList();
    this.getProjectList();
  },
  methods: {
    _initKeyword() {
      //初始化年月(获取当前的)
      var date = new Date();
      let year = date.getFullYear()
      let month = date.getMonth()
      this.keyword.year = year.toString()
      this.keyword.month = month.toString()
    },
    getUserInfoCollect(query) {
      if (query) {
        Http.get(Http.getPreBaseURL() + "/oa/PreUserInfo/getUserInfoCollect", {
          keyword: query
        }, res => {
          if (res.code === 0) {
            this.options = res.data;
          } else {
            this.$message.error({
              message: res.msg,
              type: "error",
            });
          }
        })
      }
    },

    exportSalary() {
      var params = {
        year: this.keyword.year,
        month: this.keyword.month,
        project_ids: this.keyword.project_ids,
        activeName: 'salary'
      }
      if (params.year === '' || params.month === '') {
        this.$message({
          message: '请输入年份和月份才能导出记录',
          type: 'error'
        });
        return false;
      }
      Http.get(Http.getPreBaseURL() + "/oa/PreUserSalary/exportSalary", params, res => {
        if (res) {
          window.open(Http.getPreBaseURL() + res.data)
          this.$message({
            message: '导出成功',
            type: 'success'
          });
        } else {
          this.$message.error({
            message: '导出失败',
            type: "error",
          });
        }
      })
    },
    exportOriginSalary() {
      var params = {
        name: this.keyword.name,
        year: this.keyword.year,
        month: this.keyword.month,
        page: this.pageData.page,
        page_size: this.pageData.page_size,
        organization: this.keyword.organization,
        project: this.keyword.project,
        identity_card: this.keyword.identity_card
      }
      if (params.year === '' || params.month === '') {
        this.$message({
          message: '请输入年份和月份才能导出记录',
          type: 'error'
        });
        return false;
      }
      Http.get(Http.getPreBaseURL() + "/oa/PreUserSalary/exportOriginSalary", params, res => {
        if (res) {
          window.open(Http.getPreBaseURL() + res.data)
          this.$message({
            message: '导出成功',
            type: 'success'
          });
        } else {
          this.$message.error({
            message: '导出失败',
            type: "error",
          });
        }
      })
    },
    clearSearch() {
      this.keyword = {}
    },
    handleTabClick() {
      this.keyword = {}
      var params = {
        department_id: this.department_id,
        name: '',
        year: this.keyword.year,
        month: this.keyword.month,
        page: 1,
        page_size: 10,
        organization: '',
        project: '',
        identity_card: '',
        level: this.nodeLevel ? this.nodeLevel : ''
      }
      this.getPreUserList(params);
    },
    //部门列表
    getHuaRuiDepartmentList(params, url) {
      Http.get(Http.getFlowBaseURL() + '/hr/department/getHuaRuiDepartmentList', params, res => {
        if (res.code === 0) {
          this.data = res.data;
          this.jurisdictionList = res.data;

        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    //pre工资列表
    getPreUserList(params) {
      //读取tabs数据
      Http.get(Http.getPreBaseURL() + "/oa/PreUserSalary/getSalaryList", params, res => {
        if (res.code === 0) {
          this.pageData.list = res.data.list.data;
          this.pageData.total = res.data.list.total;
          this.statusTotal = res.data.status_total;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    //单选部门list
    checkedGetList(params, url) {
      Http.get(Http.getFlowBaseURL() + "/hr/department/getHuaRuiDepartmentList", {
        parent_id: params,
      }, res => {
        if (res.code === 0) {
          this.data = res.data;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    //分页--选中页码
    pageChange(i) {
      this.pageData.page = i;
      this.pageData.page_size = 10;
      this.handleNodeClick();
    },

    //点击树形节点+搜索  = 输出表格
    handleNodeClick(data) {
      var page = ''
      var level = ''
      page = this.pageData.page
      if (data) {
        this.department_id = data.id
        level = data.level
        this.nodeLevel = data.level
        page = 1
      } else {
        level = ''
        page = this.pageData.page
      }
      var params = {
        department_id: this.department_id,
        name: this.keyword.name,
        year: this.keyword.year,
        month: this.keyword.month,
        page: page,
        page_size: this.pageData.page_size,
        organization: this.keyword.organization,
        project: this.keyword.project,
        identity_card: this.keyword.identity_card,
        project_ids: this.keyword.project_ids,
        // level:level
        level: level
      }
      this.getPreUserList(params);
    },

    //刷新右边树
    refreshTree() {
      this.getHuaRuiDepartmentList();
      this.jurisdictionId = [];
    },

    //节点下面的数据
    getData(node, resolve) {
      var region_id = node.data.id;//选中节点id
      var _this = this;
      setTimeout(() => {
        //节点不能为空
        if (region_id == '' || region_id == undefined) {
          return false;
        }
        //加载
        node.data.region_id = region_id;
        node.data && Http.get(Http.getFlowBaseURL() + '/hr/department/getHuaRuiDepartmentList', {parent_id: node.data.id,}, backdata => { // 异步执行成功后
          return resolve(backdata.data);
        });
      }, 300);
    },
    // 获取项目列表
    getProjectList() {
      let that = this
      Http.get(Http.getPreBaseURL() + '/oa/user/projectList', {}, res => {
        if (res.code === 0) {
          that.projectList = res.data
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    cellStayle({row, column, rowIndex, columnIndex}) {
      if (column.label === '实际出勤工资') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '加班费') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '其他奖励') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '高温费') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '顶岗费') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '过节费') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '应发工资') {
        return 'background-color : #FFAAAA'
      }

      if (column.label === '住房公积金') {
        if (row.housing_provident_fund > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '扣除金额') {
        if (row.agent_subtract_money_total > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '社保费') {
        if (row.social_security_money > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '公积金') {
        if (row.housing_provident_fund > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '工伤险') {
        if (row.work_injury_insurance > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '个人税') {
        if (row.personal_income_tax > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '其他扣款') {
        if (row.other_subtract_money > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '实发工资') {
        return 'background-color : #FFAAAA'
      }
      if (column.label === '考勤奖罚' || column.label === '特殊奖罚') {
        return 'background-color : #e7d4c1'
      }
    },
  }
}

</script>
<style lang="scss" scoped>
.el-button--primary,
.el-button--danger,
.el-button--success,
.el-button--warning {
    color: #fff;
}

.el-tree-node__label {
    font-size: 12px;
}

.check-work-body {
    padding: 15px;
    width: 98%;
}

.search-wrap {
    padding-bottom: 15px;
    border-bottom: 1px solid #EBEEF5;
}

.table-wrap {
    margin-top: 5px;
    //height: calc(70vh) !important;
    //overflow: auto !important;
}

.pagination-wrap {
    display: flex;
    justify-content: center;
    margin-top: 15px;
}


.check-work-tb {
    border-collapse: collapse;

    td,
    th {
        border: 1px solid #EBEEF5;
        line-height: 20px;
        padding: 10px 10px;
        font-size: 12px;
    }

    th {
        font-weight: bold;
        text-align: left;
    }
}

.el-calendar-table .el-calendar-day {
    height: 50px;
}

.check-work-class-editor {
    margin-top: 10px;
    width: 100%;

    .cw-header {
        width: 100%;
        display: table;
        border-collapse: collapse;

        .cw-title {
            display: table-cell;
            border: 1px solid #EBEEF5;
            padding: 5px 10px;
            line-height: 20px;
            font-weight: bold;

            &.cw-name {
                width: 100px;
            }

            &.cw-class {
                flex: 1;
            }
        }

    }

}

.d-flex {
    display: flex;
}

.d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
}

.d-flex-right {
    //flex: 1;
}

.form-input {
    width: 100%;
}

.table-wrap {
    //width: calc(100vw - 450px);
    //overflow-x: scroll;
    //width: 100%;

}

.amap-box {
    width: 500px;
    height: 500px;
}

.el-tree-1 {

    overflow-y: scroll;
    height: calc(100vh - 180px);
    width: 100%;
}


.fangtai-name {
    font-size: 12px;
}

.tree-wrap {
    width: 250px;
}

.project-selector {
    margin-bottom: 10px;
    display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/PreSalary.vue